import React, { HTMLAttributes } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import PageSection from "components/layout/PageSection";
import CodemastersSection from "./codemasters/CodemastersSection";
import LicensingSection from "./licensing/LicensingSection";
import Spacer from "components/Spacer";
import SocialMediaIcons from "components/SocialMediaIcons";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {
            flex: 0,
            marginTop: -10,
        },
        background: {
            backgroundColor: theme.palette.background.default,
            color: theme.palette.common.white,
        },
        contentContainer: {
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingTop: theme.spacing(1),
        },
    });
});

type IClasses = Partial<ReturnType<typeof useStyles>>;

export interface IFooterProps extends HTMLAttributes<HTMLElement> {
    classes?: IClasses;
}

export default function Footer(props: IFooterProps) {
    const { className, classes: overideClasses, ...rest } = props;
    const classes = useStyles();

    return (
        <PageSection
            className={clsx(className, classes.root, overideClasses?.root)}
            classes={{ skewedSectionRoot: clsx(classes.background, overideClasses?.background) }}
            skewed
            topSeparatorVariant="black"
            {...rest}
        >
            <div className={clsx(classes.contentContainer, overideClasses?.contentContainer)}>
                <SocialMediaIcons />
                <Spacer size={3} />
                <CodemastersSection />
                <Spacer size={2} />
                <LicensingSection />
            </div>
        </PageSection>
    );
}
